import React, { Component } from "react";
import keltnerchannel from "keltnerchannel";
import "./indicators.scss";

const kc = keltnerchannel.kc;

export default class KeltnerChannel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  render() {
    const display = this.props.display;
    const length = this.props.length;

    const histo = this.props.histo.slice(
      this.props.histo.length - display,
      this.props.histo.length
    );
    const test = this.props.histo.slice(
      this.props.histo.length + 1 - (display + length),
      this.props.histo.length
    );

    let largest = Math.max.apply(
      Math,
      histo.map((candle) => candle.high)
    );
    let smallest = Math.min.apply(
      Math,
      histo.map((candle) => candle.low)
    );

    const keltner = kc(test, length, 1, false);

    //console.log(keltner)

    const range = largest - smallest;

    const candleWidth = 400 / histo.length;
    const boxWidth = 400;
    const boxHeight = 200;

    // const mid = keltner.mid.map((kelt,i) => {
    //     const keltpoint = ((largest - kelt)/range)*200
    //     return ' M ' + (candleWidth*i)+(candleWidth/4) + ', ' + keltpoint + ' '
    // })
    let upperPoints = "";
    keltner.upper.forEach((kelt, i) => {
      const keltpoint = ((largest - kelt) / range) * boxHeight;
      upperPoints =
        upperPoints +
        (i === 0
          ? " M -" + candleWidth / 4 + 0.5 + " " + keltpoint + " "
          : " L") +
        (candleWidth * i + candleWidth / 4) +
        " " +
        keltpoint +
        " " +
        (i === keltner.upper.length - 1
          ? " L " +
            (candleWidth * (i + 1) + candleWidth / 4) +
            0.5 +
            " " +
            keltpoint
          : "");

      //upperPoints =  upperPoints + ((i === 0) ? ' M ' : ' L ') + (candleWidth* (i - 1)) + ', ' + keltpoint + ' '
    });
    let lowerPoints = "";
    keltner.lower.reverse().forEach((kelt, i) => {
      const keltpoint = ((largest - kelt) / range) * boxHeight;
      lowerPoints =
        lowerPoints +
        (i === 0
          ? " L " +
            (boxWidth - (candleWidth * i - candleWidth / 4)) +
            0.5 +
            " " +
            keltpoint +
            " "
          : " L ") +
        (boxWidth - (candleWidth * (i + 1) - candleWidth / 4)) +
        " " +
        keltpoint +
        " " +
        (i === keltner.upper.length - 1
          ? " L " +
            (boxWidth - (candleWidth * (i + 1) + candleWidth / 4)) +
            0.5 +
            " " +
            keltpoint
          : "");

      //lowerPoints = lowerPoints + ' L ' + ((boxWidth - (candleWidth*i)) - candleWidth*4) + ', ' + keltpoint + ' '
    });

    //   bollinger.upper.forEach((boll,i) => {
    //     const bollpoint = ((largest - boll)/range)*boxHeight
    //       upperPoints =  upperPoints + ((i === 0) ? ' M -' + candleWidth/4 + ' ' + bollpoint + ' ' : ' L') +
    //       (candleWidth * i + candleWidth/4) + ' ' + bollpoint + ' ' +
    //       ((i === bollinger.upper.length -1 ) ? ' L ' + (candleWidth * (i+1) + candleWidth/4) + ' ' + bollpoint : '')
    // })

    // bollinger.lower.reverse().forEach((boll,i) => {
    //     const bollpoint = ((largest - boll)/range)*boxHeight
    //       lowerPoints = lowerPoints + ((i === 0) ? ' L ' + (boxWidth - (candleWidth*(i) - candleWidth/4)) + ' ' + bollpoint + ' ' : ' L ') +
    //       (boxWidth - (candleWidth*(i + 1) - candleWidth/4)) + ' ' + bollpoint + ' ' +
    //       ((i === bollinger.upper.length -1 ) ? ' L ' + (boxWidth - (candleWidth*(i + 1) + candleWidth/4)) + ' ' + bollpoint : '')
    // })

    const d = keltner.upper.length ? upperPoints + lowerPoints + " Z" : "";

    return (
      <svg
        className="keltner-channel-chart"
        viewBox="0 0 400 200"
        preserveAspectRatio="none"
      >
        <path
          style={{
            stroke: "rgba(41,226,167,0.3)",
            fill: "rgba(41,226,226,0.1)",
            strokeMiterLimit: 10,
          }}
          d={d}
        />
      </svg>
    );
  }
}
